import styled from 'styled-components';

import { LinksWrapper } from '../Header/LinksDropDown/styled';

export const TextWrapper = styled.a`
  display: block;
  color: ${({ theme }): string => theme.colors!.colorWhite2};
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  font-size: ${({ theme }): string => theme.spacers!.spacer03};
  line-height: 100%;
  text-align: center;
  letter-spacing: 0;
  text-transform: uppercase;
  border-radius: ${({ theme }): string => theme.spacers!.spacer01};
  padding: ${({ theme }): string => `${theme.spacers!.spacer02} ${theme.spacers!.spacer04}`};
  gap: ${({ theme }): string => `${theme.spacers!.spacer02} ${theme.spacers!.spacer02}`};
  position: relative;

  @media only screen and (max-width: 920px) {
    padding: 0;
  }

  &:hover {
    color: ${({ theme }): string => theme.colors!.colorWhite5};
  }
    
  &:hover path  {
    fill: ${({ theme }): string => theme.colors!.colorWhite5};
  }
  &:hover span  {
    color: ${({ theme }): string => theme.colors!.colorWhite5};
  }

  svg {
    position: absolute;
    top: 10px;
    right: -10px;
    > path {
      fill: ${({ theme }): string => theme.colors!.colorWhite2};
    }
`;

export const GroupLinkWrapper = styled.div`
  margin-right: ${({ theme }): string => theme.spacers!.spacer04};
  position: relative;

  &:hover {
    &:after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 0;
      right: 0;
      height: 20px;
    }
    ${LinksWrapper} {
      display: block;
    }
  }
`;
